export default __webpack_public_path__ + "static/media/Experience_GalleryFirst_Vertical.c0af00ce.png";